import { Box, CircularProgress, Divider, Typography } from "@mui/joy";
import { FormProvider, useForm } from "react-hook-form";
import { useEffect } from "react";

import { OrganizationConfiguration, Action } from "./components";
import useEditOrganization from "./hooks/useEditOrganization";
import newOrganizationResolver from "../../../../libs/form-validations/organization";
import Breadcrumb from "./components/Breadcrumb";

import { Alert } from "../../../../shared";

const INITIAL_VALUES = {
    Name: "",
    IsActive: true,
};

export default function Edit() {
    const { handleEditOrganization, editOrganizationSvc, organizationData, isLoading } = useEditOrganization();

    const methods = useForm({
        resolver: newOrganizationResolver,
        defaultValues: INITIAL_VALUES,
    });

    useEffect(() => {
        if (organizationData) {
            methods.reset({
                Name: organizationData.Name,
                IsActive: organizationData.IsActive,
            });
        }
    }, [organizationData, methods]);

    const onSubmit = methods.handleSubmit(handleEditOrganization);

    if (isLoading) {
        return (
            <Box flex={1} display="flex" justifyContent="center" alignItems="center">
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box flex={1}>
            <Breadcrumb />

            <Divider />

            <Box p={3} pb={0}>
                <Typography level="title-lg">Edit Organization</Typography>
                <Typography level="body-sm">Update the details for the organization.</Typography>
            </Box>
            <Box component={"div"} ml={3} width={700}>
                <FormProvider {...methods}>
                    <form onSubmit={onSubmit}>
                        <Box display={"flex"} gap={2} flexDirection={"column"}>
                            <OrganizationConfiguration />
                            <Action api={editOrganizationSvc} />
                            <Alert
                                successMessage={editOrganizationSvc.isSuccess && "Organization updated successfully!"}
                                sx={{ mt: 3 }}
                                errorMessage={
                                    editOrganizationSvc.isError && "Failed to update organization. Please try again."
                                }
                            />
                        </Box>
                    </form>
                </FormProvider>
            </Box>
        </Box>
    );
}
